import React, { Component } from 'react';
import { MultiDropdownList } from '@appbaseio/reactivesearch';
import MultiDropdownListWithFocus from '../../components/MultiDropdownListWithFocus';

class FancyColorIntensity extends Component {
  render() {
    return (
      <div className="fancy-color-intensity form-field-wrap">
        <MultiDropdownList
          className="form-field unknown"
          title="Fancy Color Int"
          componentId="FancyColorIntensity"
          dataField={"FancyColorIntensity.keyword"}
          size={100}
          sortBy="asc"
          showCount={false}
          showSearch={true}
          renderListItem={label => (
            <div>{label !== "NULL" ? label : "None"}</div>
          )}
        />
      </div>
    );
  }
}
export default MultiDropdownListWithFocus(FancyColorIntensity);